export default __webpack_public_path__ + "static/media/Component45–1.7562cf46.svg";